import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const ShelterNews = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="74" viewBox="0 0 76 74" width="76" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M68.35 5.06 52.67 4.04h-.1q-1.35-.1-2.71.1-1.64.23-3.18.82l-35.9 12.9A2.8 2.8 0 0 0 9 20.49v21.18c0 1.29.9 2.4 2.15 2.71l9.53 2.28V63.1c0 1.16.7 2.19 1.76 2.61l7.7 3.2c1.86.77 3.9-.59 3.9-2.57V49.89l14.17 2.6q.83.21 1.66.3 1.34.2 2.74.2h.1q1.09-.01 2.18-.17l13.66-1.96a2.8 2.8 0 0 0 2.41-2.77V7.85a2.8 2.8 0 0 0-2.6-2.78zM53.4 19.52h.5q.08-.01.17.04-.33-.05-.66-.04Zm8.84 6.49q.13.2.16.46c.04.13.07.3.07.43a8 8 0 0 0-.23-.9Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M47.71 53.01q-1.4 0-2.74-.2-.83-.1-1.66-.29l-14.16-2.6-13.37-3.25-9.53-2.28a2.8 2.8 0 0 1-2.14-2.72V20.5c0-1.15.73-2.18 1.79-2.61L41.79 4.96q1.53-.59 3.18-.83 1.35-.2 2.71-.1c-1.45 0-2.71 1.4-2.71 2.86v43.24a2.83 2.83 0 0 0 2.74 2.88Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M66.07 7.85V48.1a2.8 2.8 0 0 1-2.4 2.78L50 52.84q-1.09.16-2.18.17h-.1a2.83 2.83 0 0 1-2.74-2.88v-12.8a9 9 0 0 0 5.4.5q.9-.17 1.75-.53a9.3 9.3 0 0 0 5.65-8.54q.01-.55-.06-1.12-.04-.37-.13-.73-.01-.22-.07-.43-.03-.26-.16-.46l-.3-.87-.4-.79q-.16-.41-.46-.76-.24-.34-.53-.7-.25-.3-.5-.55l-.26-.27q-.57-.56-1.22-.96c-.24-.2-.5-.33-.76-.47q-.56-.32-1.16-.52a3 3 0 0 0-1.02-.3 1 1 0 0 0-.37-.1q-.1-.03-.27-.05-.44-.1-.92-.1-.08-.05-.17-.04h-.5q-1.9 0-3.54.7V6.89c0-1.46 1.25-2.85 2.71-2.85h.1l15.68 1.02a2.8 2.8 0 0 1 2.62 2.78z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M29.15 49.9v16.44a2.82 2.82 0 0 1-3.9 2.59l-7.71-3.21a2.8 2.8 0 0 1-1.76-2.6V46.66z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M57.76 28.76a9.3 9.3 0 0 1-12.8 8.57V20.22a9 9 0 0 1 5.13-.56l.26.06a1 1 0 0 1 .37.1q.55.1 1.02.3a8 8 0 0 1 1.92.98q.66.41 1.22.96l.27.27q.25.26.5.56a9 9 0 0 1 .98 1.45l.4.8.3.86q.15.45.23.89.09.37.13.73.09.59.07 1.12z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path d="M33.1 24.06v12.51h-6.25v-6.25H20.6v6.25h-6.25V24.06z" fill={shades.black} />
    </svg>
  );
};
